package br.com.texeratx.boardgametimeapp.ui.theme

import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.ui.graphics.Color

internal val DefaultAppColorScheme = lightColorScheme(
    primary = Color(0xFF7A4E2D),
    onPrimary = Color(0xFFFDF9F4),
    primaryContainer = Color(0xFFE3CDAF),
    onPrimaryContainer = Color(0xFF3A2414),
    secondary = Color(0xFFC49A45),
    onSecondary = Color(0xFF2E1E0C),
    secondaryContainer = Color(0xFFEAD7B0),
    onSecondaryContainer = Color(0xFF3A2A12),
    tertiary = Color(0xFF8F6A3A),
    onTertiary = Color(0xFFF9F4EB),
    tertiaryContainer = Color(0xFFD9C0A1),
    onTertiaryContainer = Color(0xFF2F2110),
    background = Color(0xFFF2E7D5),
    onBackground = Color(0xFF2E2418),
    surface = Color(0xFFDBC6A3),
    surfaceDim = Color(0xFFD2BC97),
    surfaceBright = Color(0xFFF3E8D7),
    surfaceContainerLowest = Color(0xFFF9F1E4),
    surfaceContainerLow = Color(0xFFEDDDC2),
    surfaceContainer = Color(0xFFE4CEAE),
    surfaceContainerHigh = Color(0xFFDDC6A3),
    surfaceContainerHighest = Color(0xFFD6BD98),
    onSurface = Color(0xFF2E2418),
    surfaceVariant = Color(0xFFD1B894),
    onSurfaceVariant = Color(0xFF63533D),
    outline = Color(0xFFA8875A),
    outlineVariant = Color(0xFFC6AD85),
    error = Color(0xFFB3261E),
    onError = Color(0xFFFFFFFF),
    errorContainer = Color(0xFFF9DEDC),
    onErrorContainer = Color(0xFF410E0B),
)

internal val ShadowAppColorScheme = darkColorScheme(
    primary = Color(0xFF5D6B7D),
    onPrimary = Color(0xFFF2F5FA),
    primaryContainer = Color(0xFF2B3442),
    onPrimaryContainer = Color(0xFFD8E1EF),
    secondary = Color(0xFF8A6A3E),
    onSecondary = Color(0xFFF4EADC),
    secondaryContainer = Color(0xFF3A2E21),
    onSecondaryContainer = Color(0xFFE7D6BF),
    tertiary = Color(0xFF697A66),
    onTertiary = Color(0xFFF3FAF1),
    tertiaryContainer = Color(0xFF2A362B),
    onTertiaryContainer = Color(0xFFCEE0CD),
    background = Color(0xFF0D1117),
    onBackground = Color(0xFFE5EAF3),
    surface = Color(0xFF233042),
    surfaceDim = Color(0xFF1A2432),
    surfaceBright = Color(0xFF2A3A4F),
    surfaceContainerLowest = Color(0xFF141D29),
    surfaceContainerLow = Color(0xFF1B2736),
    surfaceContainer = Color(0xFF233246),
    surfaceContainerHigh = Color(0xFF2B3D54),
    surfaceContainerHighest = Color(0xFF324862),
    onSurface = Color(0xFFE5EAF3),
    surfaceVariant = Color(0xFF2D3E54),
    onSurfaceVariant = Color(0xFFBECADE),
    outline = Color(0xFF5C7391),
    outlineVariant = Color(0xFF3E526A),
    error = Color(0xFFFFB4AB),
    onError = Color(0xFF690005),
    errorContainer = Color(0xFF93000A),
    onErrorContainer = Color(0xFFFFDAD6),
)
